// Preserve cents unless the displayed, rounded fraction is exactly zero.
export function formatCurrencyAmount(value, locale = 'hr-HR') {
	const options = {minimumFractionDigits: 2, maximumFractionDigits: 2};
	const formatter = new Intl.NumberFormat(locale, options);
	const fraction = formatter.formatToParts(value).find(part => part.type === 'fraction')?.value;
	return fraction === '00'
		? new Intl.NumberFormat(locale, {...options, minimumFractionDigits: 0}).format(value)
		: formatter.format(value);
}
